import {Sudbina} from "../../../komponente/sudbina/Sudbina"
import podaci from './podaci.json'

export default class Opkoljen extends Sudbina {
  constructor() {
    super(podaci)
  }
}



// WEBPACK FOOTER //
// ./src/hronologija/1943/03-15/Opkoljen.js